module.exports = "var react = require('react');\r\nvar Tiles = require('react-tiles');,\r\nvar resolver = require('react-tiles/src/react-router-resolver');\r\n\r\nvar App = React.createClass({\r\n  render(){\r\n    return (\r\n      <Tiles resolver={ resolver } { ...this.props } />\r\n    )\r\n  }\r\n});\r\n\r\nmodule.exports = App;\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./snippets/usage.html
 ** module id = 266
 ** module chunks = 0
 **/